import { BASE_URL } from './SendMessageWithThread';
import {
  DEFAULT_AI_GPT_MODEL,
  DEFAULT_AI_IMAGE_GENERATION_MODEL,
} from './aiModels';

export type ChatBotInputMessage = Array<{
  role: string;
  content: Array<{ type: string; text: string }>;
}>;

export interface IChatBotImageGenerationOutput {
  type: string;
  status?: string;
  result?: string;
}

export interface IChatBotImageGenerationResponse {
  output?: IChatBotImageGenerationOutput[];
}

async function sendPromptToGenerateImageChatbot(
  content: ChatBotInputMessage,
  model: string = DEFAULT_AI_GPT_MODEL,
  imageModel: string = DEFAULT_AI_IMAGE_GENERATION_MODEL
): Promise<IChatBotImageGenerationResponse | null> {
  if (!content || content.length === 0) return null;

  try {
    const bodyPayload = {
      model,
      input: content,
      tools: [
        {
          type: 'image_generation',
          model: imageModel,
          size: '1536x1024',
        },
      ],
      tool_choice: { type: 'image_generation' },
      store: true,
      include: [],
    };

    const messageResponse = await fetch(BASE_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(bodyPayload),
    });

    if (!messageResponse.ok) {
      throw new Error(`HTTP error! status: ${messageResponse.status}`);
    }

    return await messageResponse.json();
  } catch (error) {
    console.error('Error generating image:', error);
    return null;
  }
}

export default sendPromptToGenerateImageChatbot;
